
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M1.16 31.49h31.49M32.66 31.4a17.26 17.26 0 00-31.49.21v6.78h31.49z"}}),_c('path',{attrs:{"d":"M6 38.09V32.3a12.54 12.54 0 0121.83-.12v6","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('rect',{attrs:{"x":"27.84","y":"10.61","width":"11","height":"4","rx":"2","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M28.62 10.93l1.64-4.17 6.15.02 1.65 4.18M33.34 6.36V.61M35.58 14.54l2.08 23.85h-6M30.04 27.04l1.13-12.5"}})])
          )
        }
      }
    